import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function UsageScenes() {
  const headerAnimation = useScrollAnimation({ threshold: 0.2 });
  const scenesAnimation = useScrollAnimation({ threshold: 0.1 });

  const scenes = [
    {
      icon: 'ri-walk-line',
      title: '散歩後',
      description: '外から帰った後の簡単ケア'
    },
    {
      icon: 'ri-moon-line',
      title: '寝る前の "香りケア"',
      description: '就寝中の獣臭を柔らかく整えます'
    },
    {
      icon: 'ri-car-line',
      title: '旅行・車内移動中',
      description: '飼い主にもペットにもリフレッシュ！'
    },
    {
      icon: 'ri-drop-line',
      title: 'シャンプーできない日',
      description: '手軽に清潔感を保つ'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'ハンドグルーミング',
      description: '手指で優しく被毛を整えるケア'
    },
    {
      icon: 'ri-leaf-line',
      title: '乾燥・抜け毛のシーズンに',
      description: '皮膚と毛に極上のうるおい'
    }
  ];

  return (
    <section className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div 
          ref={headerAnimation.ref}
          className={`text-center mb-20 space-y-6 transition-all duration-1000 ${
            headerAnimation.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
        >
          <h3 className="text-sm tracking-[0.3em] text-stone-500 font-light" style={{ fontFamily: 'Cormorant, serif' }}>
            USAGE SCENES
          </h3>
          <h2 className="text-4xl md:text-5xl leading-relaxed" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400, color: '#705e44' }}>
            <span className="md:hidden">日常の<br />あらゆるシーンで</span>
            <span className="hidden md:inline">日常のあらゆるシーンで</span>
          </h2>
          
          {/* Lead Text */}
          <div className="max-w-3xl mx-auto pt-8 space-y-6">
            <p className="text-xl leading-relaxed" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400, color: '#705e44' }}>
              こんなシーンで使って欲しい
            </p>
            <div className="text-base text-stone-600 leading-loose space-y-4" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400 }}>
              <p>
                お散歩やお出かけ後のちょっと気になる汚れと匂いに。<br />
                お風呂に入れるのは大変、そんな時こそ、Deaiwo SarangSpray!
              </p>
              <p>
                寝る前のひと拭きブラッシング。就寝中に強まる獣臭の軽減。
              </p>
              <p>
                また、旅を供にすることもあるペット。
移動中の狭い空間や車内、到着先の施設に入る前の気になる匂いや被毛の乱れを治してあげるエチケットに。
              </p>
            </div>
          </div>
        </div>

        {/* Scenes Grid */}
        <div 
          ref={scenesAnimation.ref}
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-12 max-w-5xl mx-auto"
        >
          {scenes.map((scene, index) => (
            <div 
              key={index} 
              className={`text-center space-y-6 group cursor-pointer transition-all duration-1000 ${
                scenesAnimation.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-stone-50 group-hover:bg-[#C6A87B]/10 transition-colors duration-300">
                <i className={`${scene.icon} text-4xl text-[#C6A87B]`}></i>
              </div>
              <div className="space-y-3">
                <h4 className="text-xl" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400, color: '#705e44' }}>
                  {scene.title}
                </h4>
                <p className="text-sm text-stone-600 leading-relaxed" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400 }}>
                  {scene.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
